import React from 'react';

export const Photo_Title = [
  {
    textSize: '4rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h2',
    renderContent: () => <span>FOTÓGRAFOS</span>,
  },
];

export const Photo_Erick = [
  {
    textSize: '2rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h3',
    textMobile: '2rem',
    renderContent: () => (
      <span>
        <em>ERICK</em>
        <br />
        <strong>GUEVARA</strong>
      </span>
    ),
  },
];

export const Photo_Gregory = [
  {
    textSize: '2rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h3',
    textMobile: '2rem',
    renderContent: () => (
      <span>
        <em>GREGORY</em>
        <br />
        <strong>ALLEN</strong>
      </span>
    ),
  },
];

export const Photo_Jose = [
  {
    textSize: '2rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h3',
    textMobile: '2rem',
    renderContent: () => (
      <span>
        <em>JOSÉ R</em>
        <br />
        <strong>CAGIGAS</strong>
      </span>
    ),
  },
];

export const Photo_Yvone = [
  {
    textSize: '2rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h3',
    textMobile: '2rem',
    renderContent: () => (
      <span>
        <em>YVONE</em>
        <br />
        <strong>BELANGER</strong>
      </span>
    ),
  },
];

export const Photo_Mario = [
  {
    textSize: '2rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h3',
    textMobile: '2rem',
    renderContent: () => (
      <span>
        <em>MARIO</em>
        <br />
        <strong>MACÍN</strong>
      </span>
    ),
  },
];

export const Photo_Alejandro = [
  {
    textSize: '2rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h3',
    textMobile: '2rem',
    renderContent: () => (
      <span>
        <em>ALEJANDRO</em>
        <br />
        <strong>YAÑES</strong>
      </span>
    ),
  },
];

export const Photo_Carlos = [
  {
    textSize: '2rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h3',
    textMobile: '2rem',
    renderContent: () => (
      <span>
        <em>CARLOS</em>
        <br />
        <strong>SOMONTE</strong>
      </span>
    ),
  },
];

export const Text_Jose = [
  {
    textSize: '0.938rem',
    marginBottom: '0px',
    lineHeight: '1.3',
    fontWeight: '500',
    textType: 'p',
    textMobile: '0.688rem',
    renderContent: () => (
      <span>
        José Ramón Cagigas es fotógrafo especializado en automóviles. Su trabajo
        se centra en capturar el diseño, la potencia y la identidad de cada
        vehículo a través de una mirada precisa y técnica. Con un enfoque que
        combina control de la luz, composición y detalle, desarrolla imágenes
        que resaltan tanto la estética como el carácter de los autos,
        adaptándose a producciones editoriales, comerciales y de marca.
      </span>
    ),
  },
];

export const TextPhoto1_Jose = [
  {
    textSize: '3rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>VEHÍCULOS</span>,
  },
];

export const TextPhoto2_Jose = [
  {
    textSize: '3rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>CELEBRIDADES</span>,
  },
];

export const TextPhoto3_Jose = [
  {
    textSize: '3rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>COMIDA</span>,
  },
];

export const Text_Yvone = [
  {
    textSize: '0.938rem',
    marginBottom: '0px',
    lineHeight: '1.3',
    fontWeight: '500',
    textType: 'p',
    textMobile: '0.688rem',
    renderContent: () => (
      <span>
        Yvonne Bélanger es una fotógrafa especializada en food & still life, con
        sede en la Ciudad de México y más de 20 años de experiencia profesional.
        A lo largo de su trayectoria ha colaborado con revistas, agencias de
        publicidad y clientes directos, incluyendo marcas como KFC, Bimbo,
        Danone, Domino’s Pizza, PF Chang’s, Chili’s, IHOP, Hellmann’s, Jumex y
        La Moderna, entre otras. Gracias a su amplia experiencia, puede
        adaptarse tanto a producciones en locación como en estudio. Trabaja con
        un equipo sólido de prop stylists, food stylists y retocadores,
        garantizando resultados precisos y consistentes en cada proyecto.
      </span>
    ),
  },
];

export const TextPhoto1_Yvone = [
  {
    textSize: '3rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>COMIDA</span>,
  },
];

export const TextPhoto2_Yvone = [
  {
    textSize: '3rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>SPLASH</span>,
  },
];

export const Text_Mario = [
  {
    textSize: '0.938rem',
    marginBottom: '0px',
    lineHeight: '1.3',
    fontWeight: '500',
    textType: 'p',
    textMobile: '0.688rem',
    renderContent: () => (
      <span>
        Mario Macín es un fotógrafo profesional con una sólida trayectoria en la
        fotografía artística y comercial. Su trabajo abarca el retrato, la moda,
        la publicidad y la fotografía editorial. Con formación en fotografía,
        arquitectura y danza, ha desarrollado un estilo propio que combina
        estética visual y sensibilidad artística. A lo largo de su carrera ha
        colaborado con marcas y figuras reconocidas, aportando una mirada
        contemporánea. Su obra se distingue por el uso preciso de la luz, las
        sombras y el color, y ha sido exhibida en diversas muestras,
        consolidándolo dentro de la fotografía contemporánea en México.
      </span>
    ),
  },
];

export const TextPhoto1_Mario = [
  {
    textSize: '3rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>FASHION</span>,
  },
];

export const TextPhoto2_Mario = [
  {
    textSize: '3rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>EDITORIAL</span>,
  },
];

export const TextPhoto3_Mario = [
  {
    textSize: '3rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>RETRATO</span>,
  },
];

export const Text_Gregory = [
  {
    textSize: '0.938rem',
    marginBottom: '0px',
    lineHeight: '1.3',
    fontWeight: '500',
    textType: 'p',
    textMobile: '0.688rem',
    renderContent: () => (
      <span>
        Gregory Allen es fotógrafo de moda, belleza y publicidad, con base entre
        la Ciudad de México y Nueva York. En 2017 fue nombrado Photographer of
        the Year por los Fashion Digital Awards México. Durante más de 15 años
        ha trabajado a nivel internacional con marcas como L’Oréal, Maybelline
        New York, Coppel, El Palacio de Hierro, Gerber y Nestlé, así como con
        revistas como Glamour, InStyle, Travel + Leisure y Harper’s Bazaar.
      </span>
    ),
  },
];

export const TextPhoto1_Gregory = [
  {
    textSize: '3rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>KIDS</span>,
  },
];

export const TextPhoto2_Gregory = [
  {
    textSize: '3rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>EDITORIAL</span>,
  },
];

export const TextPhoto3_Gregory = [
  {
    textSize: '3rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>CELEBRIDADES</span>,
  },
];

export const TextPhoto4_Gregory = [
  {
    textSize: '3rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>FASHION</span>,
  },
];

export const Text_Erick = [
  {
    textSize: '0.938rem',
    marginBottom: '0px',
    lineHeight: '1.3',
    fontWeight: '500',
    textType: 'p',
    textMobile: '0.688rem',
    renderContent: () => (
      <span>
        Erick Guevara es fotógrafo y artista visual especializado en retrato de
        modelos, celebridades y personajes, con un fuerte enfoque en cine y
        series. Su trabajo destaca por una estética intensa y cinematográfica,
        donde el rostro, la expresión y el carácter son el centro absoluto de la
        imagen. Ha desarrollado catálogos y carteles oficiales para producciones
        audiovisuales, combinando precisión técnica con una narrativa visual
        potente. Su fotografía no busca adornar: busca confrontar, revelar y
        permanecer.
      </span>
    ),
  },
];

export const TextPhoto1_Erick = [
  {
    textSize: '3rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>CARTELES</span>,
  },
];

export const TextPhoto2_Erick = [
  {
    textSize: '3rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>FASHION</span>,
  },
];

export const Text_Carlos = [
  {
    textSize: '0.938rem',
    marginBottom: '0px',
    lineHeight: '1.3',
    fontWeight: '500',
    textType: 'p',
    textMobile: '0.688rem',
    renderContent: () => (
      <span>
        Carlos Somonte es un fotógrafo con formación en Biología Marina por la
        Universidad Autónoma Metropolitana y estudios de posgrado en Fotografía
        en Londres. Su obra ha sido expuesta de manera individual y colectiva en
        museos y galerías de México, Inglaterra, Alemania, España, Polonia,
        Australia, China, Estados Unidos, Canadá, Cuba e India. En 2005 presentó
        una retrospectiva en el Centro de la Imagen durante FotoSeptiembre,
        exhibiendo cerca de 900 imágenes en formatos que van de Polaroid a gran
        formato 8×10. Su trabajo forma parte de colecciones y publicaciones
        internacionales.
      </span>
    ),
  },
];

export const TextPhoto1_Carlos = [
  {
    textSize: '3rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>CINE</span>,
  },
];

export const TextPhoto2_Carlos = [
  {
    textSize: '3rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>CARTELES</span>,
  },
];

export const TextPhoto3_Carlos = [
  {
    textSize: '3rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>CELEBRIDADES</span>,
  },
];

export const TextPhoto4_Carlos = [
  {
    textSize: '3rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>FASHION</span>,
  },
];

export const Text_Alejandro = [
  {
    textSize: '0.938rem',
    marginBottom: '0px',
    lineHeight: '1.3',
    fontWeight: '500',
    textType: 'p',
    textMobile: '0.688rem',
    renderContent: () => (
      <span>
        Alejandro Yañes es fotógrafo con un enfoque versátil que abarca retrato,
        paisaje, arquitectura y fotografía gastronómica. Su trabajo se
        caracteriza por una mirada sensible y bien construida, donde la
        composición, la luz y la atmósfera son protagonistas. Alterna entre el
        color y el blanco y negro para documentar personas, espacios y comida
        desde una perspectiva honesta y estética, priorizando el carácter del
        momento sobre la puesta en escena. Su fotografía conecta lo cotidiano
        con lo visualmente memorable.
      </span>
    ),
  },
];

export const TextPhoto1_Alejandro = [
  {
    textSize: '3rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>PAISAJE</span>,
  },
];

export const TextPhoto2_Alejandro = [
  {
    textSize: '3rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>CULTURAL</span>,
  },
];

export const TextPhoto3_Alejandro = [
  {
    textSize: '3rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>COMIDA</span>,
  },
];

export const TextPhoto4_Alejandro = [
  {
    textSize: '3rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>ARQUITECTURA</span>,
  },
];
